import { useState } from 'react';

const useProductFilters = () => {
  const [selectedFilter, setSelectedFilter] = useState('description');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentQuery, setCurrentQuery] = useState({ page: 1, limit: 10 });

  const buildQuery = () => {
    const query = { ...currentQuery };

    if (searchTerm) {
      query[selectedFilter] = searchTerm;
    }

    return query;
  };

  const handleFilterChange = (event) => setSelectedFilter(event.target.value);

  const handleSearchChange = (event) => setSearchTerm(event.target.value);

  const handlePaginationChange = (page, limit) => {
    setCurrentQuery({ ...currentQuery, page: page, limit: limit });
  };

  const handleSearchKeyPress = (event) => {
    if (event.key === 'Enter') {
      setCurrentQuery(buildQuery());
    }
  };

  return {
    selectedFilter,
    searchTerm,
    currentQuery,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handlePaginationChange,
  };
};

export default useProductFilters;
